import React from "react"
import { useRef,  Suspense } from "react"
import { Canvas } from "@react-three/fiber"
import {useGLTF, ContactShadows, Stage, Environment, OrbitControls } from "@react-three/drei"
import { useSnapshot } from "valtio"
import { options, turkish } from "./components/controls/state.js"
import { Picker, PickerDesc } from "./components/picker.js"
import { Car, CarSelector, Spinner } from "./components/car.js"
import { DownloadBtn, ScreenInfo, MaterialSelector } from "./components/helpers.js"

export default function App() {
  return (
    <>
      <Canvas>
        <ambientLight intensity={0.5} />
        <spotLight intensity={0.5} angle={0.1} penumbra={1} position={[10, 15, 10]} castShadow />
        <Suspense fallback={null}>
          <Car />
          <Environment preset="city" />
          <ContactShadows rotation-x={Math.PI / 2} position={[0, -0.8, 0]} opacity={0.25} width={10} height={10} blur={1.5} far={0.8} />
        </Suspense>
        <OrbitControls minPolarAngle={0} maxPolarAngle={Math.PI} enableZoom={true} enablePan={true} />
      </Canvas>
      <ScreenInfo />
      <Suspense fallback={null}>
        <MaterialSelector />
      </Suspense>
      <Picker />
      <PickerDesc />
      <CarSelector />
      <DownloadBtn />
      <Spinner />
    </>
  )
}
